import { ListOtherCharges } from '~/features/OtherCharges/ListOtherCharges'

import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

export function ListOtherChargesPage() {
  return (
    <PageContainer title='Прочие начисления'>
      <Container
        isHeader
        direction='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <PageTitle>Прочие начисления</PageTitle>
      </Container>
      <Container>
        <ListOtherCharges />
      </Container>
    </PageContainer>
  )
}
